// extracted by mini-css-extract-plugin
module.exports = {"root":"Warning-root-b859be21deec4bbdb30e0ca7aaa279c8","icon":"Warning-icon-538f9b1cc1c7de0ee7c81d593a1a6d94","message":"Warning-message-f3a96f9075945a8781992d0b5e45040e"};